import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { map, filter, publishReplay, refCount } from 'rxjs/operators';

import { Material } from './../models/material.model';
import { FICHAS } from '../../../assets/js/fichas';
import { LAVAGEM } from '../../../assets/js/lavagem';
import { RAPPORT } from '../../../assets/js/rapport';

@Injectable({
  providedIn: 'root'
})
export class MaterialService {
  // private url = '//services.focustextil.com.br/node/server/index.js?service=SearchMaterial.svc/ebook/&query=';
  // private promoUrl = '//services.focustextil.com.br/node/server/index.js?service=SearchMaterial.svc/ebookPromo/';
  // private outletUrl = '//services.focustextil.com.br/node/server/index.js?service=SearchMaterial.svc/searchOutlet/&query=';
  // private utilURL = '//services.focustextil.com.br/node/server/index.js?service=SearchMaterial.svc/util&query=';
  // private similaridadeURL = '//services.focustextil.com.br/ode/server/briefing.js?service=SearchMaterial.svc/GetSimilaridade/';
  // private corURL = '//services.focustextil.com.br/node/server/index.js?service=CorMaterial.svc/get/&query=';
  // private rapportURL = '//services.focustextil.com.br/node/server/briefing.js?service=SearchMaterial.svc/Rapport';
  // private imagePathURL = '//services.focustextil.com.br/node/server/briefing.js?service=SearchMaterial.svc/GetImgPaths/';
  // private videoPathURL = '//services.focustextil.com.br/node/server/briefing.js?service=SearchMaterial.svc/getvideopaths/';
  private url = 'http://189.126.197.169/node/server/index.js?service=SearchMaterial.svc/ebook/&query=';
  private promoUrl = 'http://189.126.197.169/node/server/index.js?service=SearchMaterial.svc/ebookPromo/';
  private outletUrl = 'http://189.126.197.169/node/server/index.js?service=SearchMaterial.svc/searchOutlet/&query=';
  private utilURL = 'http://189.126.197.169/node/server/index.js?service=SearchMaterial.svc/util&query=';
  private similaridadeURL = 'http://189.126.197.169/node/server/briefing.js?service=SearchMaterial.svc/GetSimilaridade/';
  private corURL = 'http://189.126.197.169/node/server/index.js?service=CorMaterial.svc/get/&query=';
  private rapportURL = 'http://189.126.197.169/node/server/briefing.js?service=SearchMaterial.svc/Rapport';
  private imagePathURL = 'http://189.126.197.169/node/server/briefing.js?service=SearchMaterial.svc/GetImgPaths/';
  private videoPathURL = 'http://189.126.197.169/node/server/briefing.js?service=SearchMaterial.svc/getvideopaths/';
  fichas = FICHAS;
  lavagem = LAVAGEM;
  rapport = RAPPORT;

  constructor(
    private http: HttpClient,
    private cookieService: CookieService
  ) { }

  listMaterial(search): Observable<Material[]> {
    return this.http.get<any>(this.url + search)
      .pipe(
        map(res => {
          return res.map(item => {
            return new Material(
              Math.trunc(item.ATC),
              item.ATRIBUTOS,
              item.BASE,
              item.CARACTERISTICAS,
              item.CMP1,
              item.CMP2,
              item.CMP3,
              item.CMP4,
              item.CMP5,
              item.CMP6,
              item.CODIGO_COR,
              item.CODIGO_PANTONE == null || item.CODIGO_PANTONE == '' || item.CODIGO_PANTONE == ' ' ? 'INDEFINIDO' : item.CODIGO_PANTONE,
              item.COLECAO,
              item.COMP1_BRA_FT1,
              item.COMP1_CJ_FT1,
              item.COMP2_BRA_FT1,
              item.COMP2_CJ_FT1,
              item.COMP3_BRA_FT1,
              item.COMP3_CJ_FT1,
              item.COMP4_BRA_FT1,
              item.COMP4_CJ_FT1,
              item.COMP5_BRA_FT1,
              item.COMP5_CJ_FT1,
              item.COMP6_BRA_FT1,
              item.COMP6_CJ_FT1,
              item.COMPRIMENTO_RAP,
              item.DATA_ATC,
              item.DATA_PE,
              item.DESENHO,
              item.EBOOK_CODE,
              item.EBOOK_PAGE,
              item.ETIQUETA,
              item.GRAMATURA_M,
              item.GRAMATURA_ML,
              item.GRUPO,
              item.GRUPO_CORES,
              item.LARGURA_RAP,
              parseFloat(item.LARGURA_TOTAL),
              parseFloat(item.LARGURA_UTIL),
              item.MAKTX,
              item.MANDT,
              item.MATNR,
              item.MEDIA_PECA,
              item.MOTIVO_DETALHE,
              item.MOTIVO_PADRAO,
              item.ONCAS,
              Math.trunc(item.PE),
              item.PERCENT1,
              item.PERCENT1_BRA_FT1,
              item.PERCENT1_CJ_FT1,
              item.PERCENT2,
              item.PERCENT2_BRA_FT1,
              item.PERCENT2_CJ_FT1,
              item.PERCENT3,
              item.PERCENT3_BRA_FT1,
              item.PERCENT3_CJ_FT1,
              item.PERCENT4,
              item.PERCENT4_BRA_FT1,
              item.PERCENT4_CJ_FT1,
              item.PERCENT5,
              item.PERCENT5_BRA_FT1,
              item.PERCENT5_CJ_FT1,
              item.PERCENT6,
              item.PERCENT6_BRA_FT1,
              item.PERCENT6_CJ_FT1,
              item.RENDIMENTO,
              item.SGRUPO,
              item.TECIMENTO,
              item.UNIDADE_MEDIDA == 'KG' || item.UNIDADE_MEDIDA == 'kg' || item.UNIDADE_MEDIDA == 'Kg' || item.UNIDADE_MEDIDA == 'kG' ? 'kg' : 'm',
              item.UTILIZACAO,
            );
          });
        }),
        publishReplay(1),
        refCount()
      )
  }

  listFavorite(items: any): Observable<Material[]> {
    let results = []
    items.forEach((key) => {
      results.push(this.listMaterial(key).pipe(map(res => res[0])));
    });
    return forkJoin(results);
  }

  promoMaterial(promoId): Observable<Material[]> {
    return this.http.get<any>(this.promoUrl + promoId + '&query=0')
      .pipe(
        map(res => {
          return res.map(item => {
            return new Material(
              Math.trunc(item.ATC),
              item.ATRIBUTOS,
              item.BASE,
              item.CARACTERISTICAS,
              item.CMP1,
              item.CMP2,
              item.CMP3,
              item.CMP4,
              item.CMP5,
              item.CMP6,
              item.CODIGO_COR,
              item.CODIGO_PANTONE == null || item.CODIGO_PANTONE == '' || item.CODIGO_PANTONE == ' ' ? 'INDEFINIDO' : item.CODIGO_PANTONE,
              item.COLECAO,
              item.COMP1_BRA_FT1,
              item.COMP1_CJ_FT1,
              item.COMP2_BRA_FT1,
              item.COMP2_CJ_FT1,
              item.COMP3_BRA_FT1,
              item.COMP3_CJ_FT1,
              item.COMP4_BRA_FT1,
              item.COMP4_CJ_FT1,
              item.COMP5_BRA_FT1,
              item.COMP5_CJ_FT1,
              item.COMP6_BRA_FT1,
              item.COMP6_CJ_FT1,
              item.COMPRIMENTO_RAP,
              item.DATA_ATC,
              item.DATA_PE,
              item.DESENHO,
              item.EBOOK_CODE,
              item.EBOOK_PAGE,
              item.ETIQUETA,
              item.GRAMATURA_M,
              item.GRAMATURA_ML,
              item.GRUPO,
              item.GRUPO_CORES,
              item.LARGURA_RAP,
              parseFloat(item.LARGURA_TOTAL),
              parseFloat(item.LARGURA_UTIL),
              item.MAKTX,
              item.MANDT,
              item.MATNR,
              item.MEDIA_PECA,
              item.MOTIVO_DETALHE,
              item.MOTIVO_PADRAO,
              item.ONCAS,
              Math.trunc(item.PE),
              item.PERCENT1,
              item.PERCENT1_BRA_FT1,
              item.PERCENT1_CJ_FT1,
              item.PERCENT2,
              item.PERCENT2_BRA_FT1,
              item.PERCENT2_CJ_FT1,
              item.PERCENT3,
              item.PERCENT3_BRA_FT1,
              item.PERCENT3_CJ_FT1,
              item.PERCENT4,
              item.PERCENT4_BRA_FT1,
              item.PERCENT4_CJ_FT1,
              item.PERCENT5,
              item.PERCENT5_BRA_FT1,
              item.PERCENT5_CJ_FT1,
              item.PERCENT6,
              item.PERCENT6_BRA_FT1,
              item.PERCENT6_CJ_FT1,
              item.RENDIMENTO,
              item.SGRUPO,
              item.TECIMENTO,
              item.UNIDADE_MEDIDA == 'KG' || item.UNIDADE_MEDIDA == 'kg' || item.UNIDADE_MEDIDA == 'Kg' || item.UNIDADE_MEDIDA == 'kG' ? 'kg' : 'm',
              item.UTILIZACAO,
            );
          });
        }),
        publishReplay(1),
        refCount()
      )
  }

  outletMaterial(search): Observable<Material[]> {
    return this.http.get<any>(this.outletUrl + search + '/0/0')
      .pipe(
        map(res => {
          return res.map(item => {
            return new Material(
              item.ATC,
              item.ATRIBUTOS,
              item.BASE,
              item.CARACTERISTICAS,
              item.CMP1,
              item.CMP2,
              item.CMP3,
              item.CMP4,
              item.CMP5,
              item.CMP6,
              item.CODIGO_COR,
              item.CODIGO_PANTONE == null || item.CODIGO_PANTONE == '' || item.CODIGO_PANTONE == ' ' ? 'INDEFINIDO' : item.CODIGO_PANTONE,
              item.COLECAO,
              item.COMP1_BRA_FT1,
              item.COMP1_CJ_FT1,
              item.COMP2_BRA_FT1,
              item.COMP2_CJ_FT1,
              item.COMP3_BRA_FT1,
              item.COMP3_CJ_FT1,
              item.COMP4_BRA_FT1,
              item.COMP4_CJ_FT1,
              item.COMP5_BRA_FT1,
              item.COMP5_CJ_FT1,
              item.COMP6_BRA_FT1,
              item.COMP6_CJ_FT1,
              item.COMPRIMENTO_RAP,
              item.DATA_ATC,
              item.DATA_PE,
              item.DESENHO,
              item.EBOOK_CODE,
              item.EBOOK_PAGE,
              item.ETIQUETA,
              item.GRAMATURA_M,
              item.GRAMATURA_ML,
              item.GRUPO,
              item.GRUPO_CORES,
              item.LARGURA_RAP,
              parseFloat(item.LARGURA_TOTAL),
              parseFloat(item.LARGURA_UTIL),
              item.MAKTX,
              item.MANDT,
              item.MATNR,
              item.MEDIA_PECA,
              item.MOTIVO_DETALHE,
              item.MOTIVO_PADRAO,
              item.ONCAS,
              Math.trunc(item.PE),
              item.PERCENT1,
              item.PERCENT1_BRA_FT1,
              item.PERCENT1_CJ_FT1,
              item.PERCENT2,
              item.PERCENT2_BRA_FT1,
              item.PERCENT2_CJ_FT1,
              item.PERCENT3,
              item.PERCENT3_BRA_FT1,
              item.PERCENT3_CJ_FT1,
              item.PERCENT4,
              item.PERCENT4_BRA_FT1,
              item.PERCENT4_CJ_FT1,
              item.PERCENT5,
              item.PERCENT5_BRA_FT1,
              item.PERCENT5_CJ_FT1,
              item.PERCENT6,
              item.PERCENT6_BRA_FT1,
              item.PERCENT6_CJ_FT1,
              item.RENDIMENTO,
              item.SGRUPO,
              item.TECIMENTO,
              item.UNIDADE_MEDIDA == 'KG' || item.UNIDADE_MEDIDA == 'kg' || item.UNIDADE_MEDIDA == 'Kg' || item.UNIDADE_MEDIDA == 'kG' ? 'kg' : 'm',
              item.UTILIZACAO,
            );
          });
        }),
        publishReplay(1),
        refCount()
      )
  }

  getMaterialUtil(util) {
    return this.http.get<any>(this.utilURL + util);
  }

  getMaterialSimilaridade(materialID) {
    return this.http.get<any>(this.similaridadeURL + materialID);
  }

  getMaterialCor(materialID) {
    return this.http.get<any>(this.corURL + materialID + '/E');
  }

  getRapport() {
    return this.http.get<any>(this.rapportURL);
  }

  getMaterialImagePath(materialID) {
    return this.http.get<any>(this.imagePathURL + materialID);
  }

  getLavagem(materialID) {
    return this.lavagem.filter(function(ficha) {
      return -1 !== materialID.indexOf(ficha.MATNR);
    });
  }

  getFichas(materialID) {
    return this.fichas.filter(function(ficha) {
      return -1 !== materialID.indexOf(ficha.MATNR);
    });
  }

  getMaterialVideoPath(materialID) {
    return this.http.get<any>(this.videoPathURL + materialID);
  }

}
